if (!customElements.get('wlsn-buybox-upsells')) {
  class WLSNBuyboxUpsells extends HTMLElement {
    connectedCallback() {
      this.addEventListener('click', this.handleClick);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.handleClick);
    }

    handleClick = async (event) => {
      const button = event.target.closest('[data-upsell-add]');
      if (!button || !this.contains(button) || button.disabled) return;

      const variantId = Number(button.dataset.variantId);
      if (!variantId) return;

      const card = button.closest('[data-upsell-card]');
      const errorElement = card?.querySelector('[data-upsell-error]');
      const cartAddUrl = window.routes?.cart_add_url || '/cart/add';

      button.disabled = true;
      button.classList.add('loading');
      if (errorElement) {
        errorElement.hidden = true;
        errorElement.textContent = '';
      }

      try {
        const response = await fetch(cartAddUrl, {
          method: 'POST',
          credentials: 'same-origin',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
          body: JSON.stringify({
            items: [{ id: variantId, quantity: 1 }],
            sections: ['wlsn-cart-icon-buble'],
            sections_url: window.location.pathname,
          }),
        });

        const data = await response.json().catch(() => ({}));
        if (!response.ok) {
          throw new Error(data.description || data.message || 'Unable to add this product to the cart.');
        }
      } catch (error) {
        if (errorElement) {
          errorElement.textContent = error.message;
          errorElement.hidden = false;
        }
      } finally {
        button.disabled = false;
        button.classList.remove('loading');
      }
    };
  }

  customElements.define('wlsn-buybox-upsells', WLSNBuyboxUpsells);
}
